import axios from 'axios';
import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { APIURL } from "../config";

function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState("");
    const [error, setError] = useState("");
    const [message, setMessage] = useState("");
    const [enableSubmit, setEnableSubmit] = useState(true);
    const [buttonText, setButtonText] = useState("Submit");
    const navigate = useNavigate();

    const forgotpasswordHandler = async () => {
        setEmailError("");
        setError("");
        setButtonText("Submitting...");
        setEnableSubmit(false);
        let isValid = true;

        if (!email) {
            setEmailError("Email is required.");
            isValid = false;
        } else {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(email)) {
                setEmailError("Invalid email format.");
                isValid = false;
            }
        }

        if (!isValid) {
            setError("Please fill in all fields correctly.");
            setButtonText("Submit");
            setEnableSubmit(true);
            return;
        }
        try {
            const response = await axios.post(APIURL + '/forgot-password', {
                email: email
            });
            if (response.status === 200) {
                setMessage("Password reset link has been sent to your email.");
            } else if (response.status === 404) {
                setError("Email not found. Please check and try again.");
            } else {
                setError("An error occurred. Please try again.");
            }
        } catch (err) {
            if (err.response && err.response.status === 404) {
                setError("Email not found. Please check and try again.");
            } else
                setError("An error occurred. Please try again.");
        }

        setButtonText("Submit");
        setEnableSubmit(true);
    };

    return (
        <div>
            <div className="loginsignup">
                <div className="loginsignup-container">
                    <h1>Forgot Password</h1>
                    <div className="loginsignup-fields">
                        <label>
                            Email Address
                            <br />
                            <input
                                type="email"
                                className="email"
                                placeholder="Enter your email address"
                                style={{ width: "540px", height: "45px" }}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            <span style={{ color: "red" }}>{emailError}</span>
                            <span style={{ color: "green" }}>{message}</span>
                        </label>
                    </div>
                    <br />
                    <button className={`submit-button ${!enableSubmit && "disable"}`} onClick={forgotpasswordHandler} disabled={!enableSubmit}>
                        {buttonText || "Submit"}
                    </button>
                    {error && <p style={{ color: "red" }}>{error}</p>}
                    <br />
                    <br />

                    <a
                        style={{ cursor: "pointer" }}
                        className="register"
                        onClick={() => navigate("/login")}
                    >
                        Already have an account? Login
                    </a>
                    <br />
                    <br />
                </div>
            </div >
        </div >
    )
}

export default ForgotPassword